module.exports = __webpack_public_path__ + "static/media/sf-test-12.6127806a.mp3";